/**
 * Production stand-in for `ngrx-store-devtools-import-debug.config.ts`, substituted by the
 * `fileReplacements` entry on the `production` configuration in angular.json.
 *
 * Exporting an empty array leaves the app module's `imports` spread with nothing to add,
 * and — the point of the exercise — leaves `@ngrx/store-devtools` with no static import
 * reachable from the entry point, so it is not bundled at all.
 */
export const storeDevtoolsImport = [];
